<template>
  <div class="c-priceinfo">
    Totalt: {{ totalPrice.toLocaleString('nb-NO') }},–
    <span
      v-if="$store.state.entities.calculatorsettings.hasCommunalPrice === true"
    >
      &nbsp; | &nbsp;{{ monthlyPrice.toLocaleString('nb-NO') }},– per måned
    </span>
  </div>
</template>

<script>
import Option from '@/models/Option';
import Residence from '@/models/Residence';

export default {
  name: 'PriceInfo',
  props: {
    residenceId: {
      type: [
        Number,
        String,
        Boolean,
      ],
      required: true,
      default: false,
    },
  },
  computed: {
    residence() {
      return Residence.find(this.residenceId);
    },
    optionsCost() {
      const options = Option.query()
        .where('isSelected', true)
        .get();
      let sum = 0;
      options.forEach(option => {
        sum += option.currentPrice;
      });
      return sum;
    },
    totalPrice() {
      return this.residence.price + this.optionsCost;
    },
    monthlyPrice() {
      return this.residence.monthlyCost;
    },
  },
};
</script>

